// extracted by mini-css-extract-plugin
var _1 = "nJK_O";
var _2 = "TM_aq";
export { _1 as "base", _2 as "chart" }
